import classNames from 'classnames';
import {isDealersLk} from 'lib/isDealersLk';
import {PaymentOptionData} from 'modules/Cart/containers/CartForm/useCartForm';
import {PaymentOption} from 'modules/Cart/containers/CartFormPaymentOptions/PaymentOption/PaymentOption';
import {
    ORDER_PAYMENT_OPTIONS,
    PaymentOptionType,
} from 'modules/Cart/lib/constants';
import {FC, MouseEvent, useCallback} from 'react';

import {Icon} from 'components/Icon/Icon';
import {Text} from 'components/Text/Text';
import {
    Tooltip,
    TooltipPosition,
    TooltipTheme,
} from 'components/Tooltip/Tooltip';

import styles from './CartFormPaymentOptions.module.css';

type Props = {
    className?: string;
    onSelect: (payment: PaymentOptionData) => void;
    selectedOption: PaymentOptionType;
};
export const CartFormPaymentOptions: FC<Props> = ({
    className,
    onSelect,
    selectedOption,
}) => {
    const makeHandleSelect = useCallback(
        (paymentOption: PaymentOptionData) => () => {
            onSelect(paymentOption);
        },
        [onSelect],
    );

    // В ЛК дилеров не показываем "покупку в кредит"
    const filterOptions = ORDER_PAYMENT_OPTIONS.filter(
        (option) =>
            option.id !== PaymentOptionType.Credit ||
            (option.id === PaymentOptionType.Credit && !isDealersLk()),
    );

    return (
        <div className={classNames(styles.block, className)}>
            {filterOptions.map((option) => (
                <PaymentOption
                    key={option.id}
                    className={styles.option}
                    active={selectedOption === option.id}
                    label={option.title}
                    iconName={option.iconName}
                    onSelect={makeHandleSelect(option)}
                    rightSlot={
                        option.id === PaymentOptionType.Credit ? (
                            <CreditRightSlot />
                        ) : null
                    }
                />
            ))}
        </div>
    );
};

function CreditRightSlot() {
    const handleClick = useCallback((e: MouseEvent) => {
        e.stopPropagation();
    }, []);
    return (
        <Tooltip
            className={styles.creditInfo}
            contentClassName={styles.creditInfoTooltip}
            theme={TooltipTheme.Light}
            position={TooltipPosition.TopRight}
            content={
                <div onClick={handleClick}>
                    <div className={styles.creditInfoTooltipContent}>
                        <Text.Semibold12>
                            Для физических: от 20 000 ₽
                        </Text.Semibold12>
                        <Text.Semibold12>
                            Для юридических лиц: от 500 000 ₽
                        </Text.Semibold12>
                    </div>
                    <div className={styles.creditInfoTooltipFooter}>
                        <a
                            href="https://www.klenmarket.ru/services/lending/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <Text.Semibold12>
                                Условия кредитования
                            </Text.Semibold12>
                        </a>
                    </div>
                </div>
            }
        >
            <Icon name="info19" className={styles.creditInfoIcon} />
        </Tooltip>
    );
}
